import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class LoginService {

  constructor(private _http: HttpClient) { }

  keyboard(register: boolean){
    let API = ''
    const header = new HttpHeaders();
    header.set('X-device-Id','BACK_OFFICE_USER_EXPRESS');
    if(register){
      API = environment.apigee + `/identity/keyboard`
    } else{
      API = environment.apigee + `/management/randomkeyboard`
    }
    return this._http.get<any>(API,{headers: header});
  }

  login(data: any){
    return this._http.post<any>(environment.login, data);
  }

}
